import React from "react";

const Floats = () => {
    return (
        <div className="floats"></div>
    );
}

export default Floats;
